import { oc } from '@orpc/contract';
import { resetUserPasswordInputSchema, userWithTemporaryPasswordSchema } from '../schemas/users.schemas.js';
export const resetUserPasswordContract = oc
    .route({
    method: 'POST',
    path: '/users/{id}/reset-password',
    tags: ['Users'],
    summary: 'Issue a new one-time temporary password and sign the user out everywhere (ADMIN)',
})
    .input(resetUserPasswordInputSchema)
    .output(userWithTemporaryPasswordSchema);
//# sourceMappingURL=reset-user-password.contract.js.map